(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4905],{

/***/ 20724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');

exports.Z = _default;

/***/ }),

/***/ 87089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
}), 'Whatshot');

exports.Z = _default;

/***/ }),

/***/ 24905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CarouselList": function() { return /* reexport */ CarouselList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(20724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowUpward.js
var ArrowUpward = __webpack_require__(54364);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDownward.js
var ArrowDownward = __webpack_require__(26613);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/CarouselList/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Arrows"
            },
            {
                name: "theme_component_list_arrow_background_color",
                label: "Arrow background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_list_arrow_hover_background_color",
                label: "Arrow Hover background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_list_arrow_svg_color",
                label: "Arrow icon color",
                type: "color",
                default: theme.palette.common.white
            },
            {
                name: "theme_component_list_arrow_width",
                label: "Arrow width",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_min_width",
                label: "Arrow minimum width",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_height",
                label: "Arrow height",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_minimum_height",
                label: "Arrow height",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Left arrow"
            },
            {
                name: "theme_component_list_arrow_left_left",
                label: "Left margin",
                type: "number",
                endAdornment: "px",
                default: 0
            },
            {
                name: "theme_component_list_arrow_left_border_radius",
                label: "Border radius",
                type: "text",
                default: "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            {
                name: "theme_component_list_arrow_left_svg_margin_left",
                label: "Icon left margin",
                type: "number",
                endAdornment: "px",
                default: theme.spacing(1)
            },
            {
                name: "theme_component_list_arrow_left_svg_font_size",
                label: "Icon size",
                type: "number",
                endAdornment: "px",
                default: theme.typography.body1.fontSize
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Right arrow"
            },
            {
                name: "theme_component_list_arrow_right_right",
                label: "Right margin",
                type: "number",
                endAdornment: "px",
                default: 0
            },
            {
                name: "theme_component_list_arrow_right_border_radius",
                label: "Border radius",
                type: "text",
                default: "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            {
                name: "theme_component_list_arrow_right_svg_margin_right",
                label: "Icon right margin",
                type: "number",
                endAdornment: "px",
                default: theme.spacing(1)
            },
            {
                name: "theme_component_list_arrow_right_svg_font_size",
                label: "Icon size",
                type: "number",
                endAdornment: "px",
                default: theme.typography.body1.fontSize
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/components/Card/index.ts + 18 modules
var Card = __webpack_require__(88124);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
;// CONCATENATED MODULE: ./src/components/CarouselList/styled.tsx



// type arrowOptions = {
//   arrowOptions?: 'default' | 'circular';
// }
var Arrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e1qp3ttq0"
})(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        zIndex: 1,
        top: "calc(50% - 30px)",
        width: theme.theme_component_list_arrow_width ? "".concat(theme.theme_component_list_arrow_width, "px") : "40px",
        minWidth: theme.theme_component_list_arrow_min_width ? "".concat(theme.theme_component_list_arrow_min_width, "px") : "40px",
        height: theme.theme_component_list_arrow_height ? "".concat(theme.theme_component_list_arrow_height, "px") : "auto",
        minHeight: theme.theme_component_list_arrow_minimum_height ? "".concat(theme.theme_component_list_arrow_minimum_height, "px") : "auto",
        backgroundColor: theme.theme_component_list_arrow_background_color || theme.palette.secondary.main,
        "& svg": {
            color: theme.theme_component_list_arrow_svg_color || theme.palette.common.white
        },
        hover: {
            backgroundColor: theme.theme_component_list_arrow_hover_background_color
        },
        "&.swiper-button-disabled": {
            filter: "grayscale(1)",
            cursor: "default"
        }
    };
});
var ArrowLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq1"
})(function(param) {
    var theme = param.theme;
    return {
        left: theme.theme_component_list_arrow_left_left ? "".concat(theme.theme_component_list_arrow_left_left, "px") : 0,
        borderRadius: theme.theme_component_list_arrow_left_border_radius || "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
        "& svg": {
            marginLeft: theme.theme_component_list_arrow_left_svg_margin_left ? "".concat(theme.theme_component_list_arrow_left_svg_margin_left, "px") : theme.spacing(1),
            fontSize: theme.theme_component_list_arrow_left_svg_font_size ? "".concat(theme.theme_component_list_arrow_left_svg_font_size, "px") : undefined
        }
    };
});
var ArrowRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq2"
})(function(param) {
    var theme = param.theme;
    return {
        right: theme.theme_component_list_arrow_right_right ? "".concat(theme.theme_component_list_arrow_right_right, "px") : 0,
        borderRadius: theme.theme_component_list_arrow_right_border_radius || "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
        "& svg": {
            marginRight: theme.theme_component_list_arrow_right_svg_margin_right ? "".concat(theme.theme_component_list_arrow_right_svg_margin_right, "px") : theme.spacing(1),
            fontSize: theme.theme_component_list_arrow_right_svg_font_size ? "".concat(theme.theme_component_list_arrow_right_svg_font_size, "px") : undefined,
            transform: "rotate(180deg)"
        }
    };
});
var ArrowUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq3"
})(function(param) {
    var theme = param.theme;
    return {
        top: "12px",
        left: 0,
        right: 0,
        margin: "auto",
        borderRadius: theme.theme_component_list_arrow_left_border_radius || "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
        "& svg": {
            fontSize: theme.theme_component_list_arrow_left_svg_font_size ? "".concat(theme.theme_component_list_arrow_left_svg_font_size, "px") : undefined
        }
    };
});
var ArrowDown = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq4"
})(function(param) {
    var theme = param.theme;
    return {
        bottom: 0,
        left: 0,
        right: 0,
        margin: "320px auto",
        marginBottom: 0,
        borderRadius: theme.theme_component_list_arrow_right_border_radius || "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
        "& svg": {
            fontSize: theme.theme_component_list_arrow_right_svg_font_size ? "".concat(theme.theme_component_list_arrow_right_svg_font_size, "px") : undefined
        }
    };
});
var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e1qp3ttq5"
})(function(param) {
    var theme = param.theme, width = param.width, height = param.height;
    return {
        boxShadow: theme.shadows[0],
        aspectRatio: "".concat(width, "/").concat(height)
    };
});
var CarouselListContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qp3ttq6"
})(function(param) {
    var vertical = param.vertical;
    return {
        height: vertical ? "inherit" : "100%",
        maxHeight: "100vw",
        minHeight: 0,
        minWidth: 0,
        maxWidth: "100vw",
        width: "100%",
        overflow: "hidden",
        ".swiper > .swiper-wrapper": {
            maxHeight: "100%",
            height: vertical ? "628px" : "100%",
            display: "flex"
        },
        ".swiper > .swiper-slide": {
            width: "auto",
            flexShrink: 0,
            display: "block",
            height: "100%",
            maxHeight: "100%"
        }
    };
});
var TrendSticker = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1qp3ttq7"
})("position:absolute;top:24px;background-color:#f9484a;background-image:linear-gradient(315deg,#f9484a 0%,#fbd72b 74%);color:yellow;padding:4px 8px;border-radius:0px 0px 8px 0px;");

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Whatshot.js
var Whatshot = __webpack_require__(87089);
;// CONCATENATED MODULE: ./src/components/CarouselList/CarouselList.tsx




















var CardStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* Card */.Zb, {
    target: "e1xo90gu0"
})(function(param) {
    var theme = param.theme, template = param.template, hoverEffect = param.hoverEffect, cardBorder = param.cardBorder;
    return {
        width: "100%",
        // height: '100%',
        backgroundColor: theme.theme_component_card_background_color || theme.palette.background.paper,
        boxShadow: theme.theme_component_card_box_shadow || theme.shadows[3],
        borderRadius: template === "big" ? 0 : "".concat(theme.theme_component_card_border_radius, "px") || 0,
        border: cardBorder || "".concat(theme.theme_component_card_content_border, "px") || 0,
        borderStyle: theme.theme_component_card_content_border ? "solid" : "none",
        borderColor: theme.theme_component_card_content_border ? theme.theme_component_card_content_border_color : "none",
        transition: "transform ".concat(theme.transitions.duration.shortest, "ms ").concat(theme.transitions.easing.easeInOut),
        "&:hover": hoverEffect && {
            transform: "scale3d(1.05, 1.05, 1)"
        }
    };
});
var defaultBreakpoints = {
    // https://mui.com/customization/breakpoints/
    // Try to keep this similar as CollectionGrid breakpoints.
    1200: {
        // lg
        slidesPerView: 6,
        slidesPerGroup: 6
    },
    900: {
        // md
        slidesPerView: 4,
        slidesPerGroup: 4
    },
    600: {
        // sm
        slidesPerView: 3,
        slidesPerGroup: 3
    },
    0: {
        // xs
        slidesPerView: 2,
        slidesPerGroup: 2
    }
};
var CarouselList = function(props) {
    var items = props.items, className = props.className, children = props.children, padding = props.padding, cardOptions = props.cardOptions, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 6 : _slidesPerView, _breakpoints = props.breakpoints, breakpoints = _breakpoints === void 0 ? defaultBreakpoints : _breakpoints, _direction = props.// arrowOptions,
    direction, direction = _direction === void 0 ? "horizontal" : _direction, swiperOptions = (0,_object_without_properties/* default */.Z)(props, [
        "items",
        "className",
        "children",
        "padding",
        "cardOptions",
        "slidesPerView",
        "breakpoints",
        "direction"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var assetUrl = appContext.useConfig().assetUrl;
    var channel = react.useRef(new Date().getTime().toString(36));
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(items || []), 1), slides = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CarouselListContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, useEditorHandlers("Carousel List")), {
        vertical: direction === "vertical",
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: {
                    padding: padding
                },
                id: channel === null || channel === void 0 ? void 0 : channel.current,
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* A11y */.s5,
                    swiper_esm/* Virtual */.eZ
                ],
                loop: (slides === null || slides === void 0 ? void 0 : slides.length) > 1,
                slidesPerView: slidesPerView,
                spaceBetween: parseInt(theme.spacing(2).replace("px ", "")),
                breakpoints: breakpoints,
                a11y: {
                    prevSlideMessage: "Previous slide",
                    nextSlideMessage: "Next slide"
                },
                navigation: {
                    prevEl: ".arrow-left-".concat(channel === null || channel === void 0 ? void 0 : channel.current),
                    nextEl: ".arrow-right-".concat(channel === null || channel === void 0 ? void 0 : channel.current)
                },
                direction: direction || "horizontal"
            }, swiperOptions), {
                children: [
                    slides.map(function(item, index) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* SwiperSlide */.o5, {
                            virtualIndex: index,
                            children: item ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardStyled, (0,_object_spread/* default */.Z)({
                                        sx: {
                                            display: "flex"
                                        },
                                        href: "/game/".concat(item.slug),
                                        src: "".concat(assetUrl).concat((cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.template) === "big" ? item.images.cover4x1 || item.images.cover16x9 || item.images.cover : item.images.cover16x9 || item.images.cover, "/"),
                                        alt: item.name || "Cover",
                                        title: item.name || undefined,
                                        description: item.description || undefined
                                    }, cardOptions)),
                                    (item === null || item === void 0 ? void 0 : item.trend) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrendSticker, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Whatshot/* default */.Z, {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, {
                                elevation: 1,
                                width: cardOptions.width,
                                height: cardOptions.height
                            })
                        }, "".concat(channel === null || channel === void 0 ? void 0 : channel.current).concat(index));
                    }),
                    direction === "horizontal" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowLeft, {
                                variant: "contained",
                                "aria-label": "Previous",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-left-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowBackIos/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowRight, {
                                variant: "contained",
                                "aria-label": "Next",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-right-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowBackIos/* default */.Z, {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUp, {
                                variant: "contained",
                                "aria-label": "Previous",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-left-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUpward/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDown, {
                                variant: "contained",
                                "aria-label": "Next",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-right-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownward/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/CarouselList/index.ts



/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);